import React from 'react';
import { AppInitializationState, useGetAppProps } from './stateStore';

export const ForwardAppProps: React.FC<{
  children: (props: { getAppProps: () => AppInitializationState<any> }) => JSX.Element;
}> = ({ children }) => {
  const getAppProps = useGetAppProps();
  return <>{children({ getAppProps })}</>;
};
